import React from 'react';
import PropTypes from 'prop-types';
import TwitterCard from '@vg/twitter-card';
import OpenGraph from '@spp/ui-open-graph';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';

const ShareMeta = ({ article }) => {
    const { promotionContent = {} } = article;

    if (!promotionContent.description) {
        return null;
    }

    const { links: { shareUrl } } = article;
    const { shareDefaults: { image: defaultShareImage } } = config;

    const {
        description: { value: articleDesc },
        title: { value: articleTitle },
    } = promotionContent;

    const { url: shareImageUrl = defaultShareImage } = promotionContent.imageAsset
        ? promotionContent.imageAsset.urls[promotionContent.imageAsset.urls.length - 1]
        : {};

    return (
        <div>
            <TwitterCard
                title={articleTitle}
                card={'summary_large_image'}
                description={articleDesc}
                image={shareImageUrl}
            />
            <OpenGraph
                title={articleTitle}
                type={'article'}
                url={shareUrl}
                description={articleDesc}
                image={shareImageUrl}
            />
        </div>
    );
};
ShareMeta.propTypes = {
    article: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default ShareMeta;



/** WEBPACK FOOTER **
 ** ./src/local-components/ShareMeta.js
 **/